import { useState, useEffect } from 'react';

const useDeviceIdentification = (deviceSize) => {
  const media = window.matchMedia(`(max-width: ${deviceSize}px)`)
  const [isDevice, setIsDevice] = useState(media.matches);

  useEffect(() => {
    const handleResize = () => {
      let media = window.matchMedia(`(max-width: ${deviceSize}px)`)      
      setIsDevice(media.matches)
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  return isDevice;
};

export default useDeviceIdentification;